module.exports = __webpack_public_path__ + "static/img/13.d378f8cc.png";